/**
 * EMU Invoice API
 * EMU Invoice API documentation<br> Do not use 403 status, use 409 instead<br>
 *
 * OpenAPI spec version: 1.0.5
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { DbDefaultResponse } from '../model/dbDefaultResponse';
import { ListFilterRequestDto } from '../model/listFilterRequestDto';
import { PeriodicInvoiceDto } from '../model/periodicInvoiceDto';
import { PeriodicInvoiceListResponseDto } from '../model/periodicInvoiceListResponseDto';
import { PeriodicInvoiceSaveDto } from '../model/periodicInvoiceSaveDto';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class PeriodicInvoiceService {
  protected basePath = 'http://127.0.0.1:4201/api/';

  public defaultHeaders = new HttpHeaders();

  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   *
   * @param id
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public periodicInvoiceControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<DbDefaultResponse>;
  public periodicInvoiceControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<DbDefaultResponse>>;
  public periodicInvoiceControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<DbDefaultResponse>>;
  public periodicInvoiceControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling periodicInvoiceControllerDelete.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<DbDefaultResponse>(
      'delete',
      `${this.basePath}/periodic-invoice/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   *
   *
   * @param id
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public periodicInvoiceControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<PeriodicInvoiceDto>;
  public periodicInvoiceControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<PeriodicInvoiceDto>>;
  public periodicInvoiceControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<PeriodicInvoiceDto>>;
  public periodicInvoiceControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling periodicInvoiceControllerGet.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<PeriodicInvoiceDto>(
      'get',
      `${this.basePath}/periodic-invoice/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   *
   *
   * @param body
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public periodicInvoiceControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<PeriodicInvoiceListResponseDto>;
  public periodicInvoiceControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<PeriodicInvoiceListResponseDto>>;
  public periodicInvoiceControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<PeriodicInvoiceListResponseDto>>;
  public periodicInvoiceControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling periodicInvoiceControllerList.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<PeriodicInvoiceListResponseDto>(
      'post',
      `${this.basePath}/periodic-invoice/list`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   *
   *
   * @param body
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public periodicInvoiceControllerSave(
    body: PeriodicInvoiceSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<any>;
  public periodicInvoiceControllerSave(
    body: PeriodicInvoiceSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<any>>;
  public periodicInvoiceControllerSave(
    body: PeriodicInvoiceSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<any>>;
  public periodicInvoiceControllerSave(
    body: PeriodicInvoiceSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling periodicInvoiceControllerSave.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>('post', `${this.basePath}/periodic-invoice`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
